import React, { Component } from "react"
import { Divider } from "antd"
import { withRouter } from "react-router"
import { Button, Label, Modal } from "semantic-ui-react"
import { Form } from "formsy-semantic-ui-react"
import styled from "styled-components"
import { signUpAndLogin } from "../api/sync/index"
import SocialLogin from "../components/SocialButton/index"

const Input = Form.Input

const Column = styled.div.attrs({
  className: "column"
})`
  max-width: 700px;
`
const StyledSignUpDiv = styled.div.attrs({
  className: "ui message mobile-mr10 mobile-ml10"
})`
  &&& {
    margin-bottom: 15px;
  }
`

class Signup extends Component {
  state = {
    email: "",
    password: "",
    canSubmit: false
  }

  disableButton = () => {
    this.setState({ canSubmit: false })
  }

  enableButton = () => {
    this.setState({ canSubmit: true })
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSubmit = async () => {
    const { email, password } = this.state

    signUpAndLogin(email.toLowerCase(), password).then(() =>
      this.props.setLogin()
    )
    this.props.onClose()
    this.props.history.push("/races/")
  }

  render() {
    const errorLabel = <Label color="red" pointing />
    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        closeOnEscape
        closeOnDimmerClick
      >
        <div className="ui column centered grid">
          <Column>
            <div style={{ textAlign: "center", marginBottom: 10 }}>
              <h2 className="ui teal image header mt10 mobile-ml15">
                สมัครสมาชิก
              </h2>
            </div>
            <SocialLogin
              onClose={this.props.onClose}
              setLogin={this.props.setLogin}
            />
            <Divider>Or, use my email address</Divider>
            <Form
              className="ui large form"
              onValidSubmit={this.handleSubmit}
              onValid={this.enableButton}
              onInValid={this.disableButton}
            >
              <div className="ui stacked segment" style={{ marginTop: 0 }}>
                <Form.Field>
                  <Input
                    validations={{
                      myCustomIsFiveValidation(values, value) {
                        if (!value) return "โปรดกรอกอีเมล / เบอร์โทรศัพท์"
                        if (!isNaN(value) && value.length !== 10)
                          return "โปรดกรอกอีเมล / เบอร์โทรศัพท์"
                        return !isNaN(value) || value.includes("@")
                          ? true
                          : "โปรดกรอกอีเมล หรือ หมายเลขโทรศัพท์"
                      }
                    }}
                    name="email"
                    icon="user"
                    iconPosition="left"
                    placeholder="อีเมล/หมายเลขโทรศัพท์"
                    errorLabel={errorLabel}
                    onChange={this.handleChange}
                  />
                </Form.Field>
                <Form.Field>
                  <Input
                    name="password"
                    icon="lock"
                    iconPosition="left"
                    type="password"
                    placeholder="Password"
                    onChange={this.handleChange}
                  />
                </Form.Field>
                <Button className="ui fluid large teal" type="submit">
                  สมัครสมาชิกเลย
                </Button>
              </div>
              <div className="ui error message" />
            </Form>

            <StyledSignUpDiv>
              ยังไม่ได้เป็นสมาชิก? <a href="#">สมัครสมาชิกเลย</a>
              <br />{" "}
              <div
                onClick={() => {
                  this.props.onClose()
                  this.props.history.push("/reset-password")
                }}
              >
                <a href="#">ลืมรหัสผ่าน?</a>
              </div>
            </StyledSignUpDiv>
          </Column>
        </div>
      </Modal>
    )
  }
}

export default withRouter(Signup)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Signup.js